import { Navigate, useParams } from 'react-router-dom';
import CategoriesPage from './pages/CategoriesPage';
import CategoryFormPage from './pages/CategoryFormPage';
import { withAppLayout } from '../core/routes';

const CategoryLegacyEditRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/products/categories/${encodeURIComponent(id)}/edit`} replace />;
};

export const categoriesRoutes = [
  { path: '/products/categories', element: withAppLayout(<CategoriesPage />) },
  { path: '/products/categories/:id/edit', element: withAppLayout(<CategoryFormPage />) },
  { path: '/categories', element: <Navigate to="/products/categories" replace /> },
  { path: '/categories/:id/edit', element: <CategoryLegacyEditRedirect /> },
];
